import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { PortalTheme } from '@navent-jobs/ui-kit/themes'
import { Provider } from 'react-redux'
import { Helmet } from 'react-helmet'
import { Suripanta } from '@navent-jobs/ui-kit/components/suripanta'
import Root from './routes'
import { store } from './store'
import { ConfigContextProvider } from './config/context'
import scripts, { Script } from './scripts'
import './i18n'
import { ASSETS_URL, NOMBRE_SITIO, NOMBRE_PAIS, IS_ZONA_JOBS } from './constants'
import LoaderToLazy from './components/LoaderToLazy'
import ModalMobile from './components/ModalMobile'
import LangProvider from './i18n/LangProvider'

const googleLoginClientId = window.GOOGLE_LOGIN_KEY_COMPANY ?? process.env.REACT_APP_GOOGLE_LOGIN_KEY_COMPANY

const Scripts = (): JSX.Element => {
  return (
    <>
      {scripts.map((script: Script) => {
        return (
          <Suripanta key={script.name} {...(script as any)}>
            {script.code}
          </Suripanta>
        )
      })}
    </>
  )
}

const HelmetsApp = () => {
  const { t } = useTranslation()
  const title = t('pageTitle', { nombreSitio: NOMBRE_SITIO, nombrePais: NOMBRE_PAIS })

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="shortcut icon" href={`${ASSETS_URL}/favicon/favicon.ico`} />
      <link rel="apple-touch-icon" sizes="180x180" href={`${ASSETS_URL}/favicon/apple-touch-icon.png`} />
      <link rel="icon" type="image/png" sizes="32x32" href={`${ASSETS_URL}/favicon/favicon-32x32.png`} />
      <link rel="icon" type="image/png" sizes="16x16" href={`${ASSETS_URL}/favicon/favicon-16x16.png`} />
      <link rel="manifest" href={`${ASSETS_URL}/favicon/site.webmanifest`} />
      <link rel="mask-icon" href={`${ASSETS_URL}/favicon/safari-pinned-tab.svg" color="#3d47f5`} />
    </Helmet>
  )
}

function App() {
  return (
    <Suspense fallback={<LoaderToLazy />}>
      <LangProvider>
        <Provider store={store}>
          <GoogleOAuthProvider clientId={googleLoginClientId}>
            <PortalTheme portal={IS_ZONA_JOBS ? 'zonajobs' : 'bumeranEmpresas'}>
              <HelmetsApp />
              <ConfigContextProvider>
                <Root />
                <ModalMobile />
              </ConfigContextProvider>
              <Scripts />
            </PortalTheme>
          </GoogleOAuthProvider>
        </Provider>
      </LangProvider>
    </Suspense>
  )
}
export default App
